import { connect } from 'react-redux'

import { UploadWhitelist } from '../components'

import * as actions from '../actions'
import * as selectors from '../selectors'

const mapStateToProps = state => ({
    totalRows: selectors.getTotalRows(state),
    invalidRows: selectors.getInvalidRows(state),
    invalidAgencyCodesData: selectors.getSpreadsheetInvalidDataForType('agencyCode', state),
    invalidEmailData: selectors.getSpreadsheetInvalidDataForType('email', state),
    duplicateEmailData: selectors.getSpreadsheetInvalidDataForType('unique', state),
    isIdle: selectors.getIsIdle(state),
    isValidating: selectors.getIsValidating(state),
    isReady: selectors.getIsReady(state),
    isUploading: selectors.getIsUploading(state),
    isSuccess: selectors.getIsSuccess(state),
    isError: selectors.getIsError(state),
    lastSuccessCount: selectors.getLastSuccessCount(state),
})

const mapDispatchToProps = {
    parseSpreadsheetData: actions.parseSpreadsheetData,
    uploadSpreadsheetData: actions.uploadSpreadsheetData,
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadWhitelist)
